import { publishEvent, TelemetryEventData } from "VSS/Telemetry/Services";
import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import { Areas, WikiTypeCI } from "Wiki/Scripts/CustomerIntelligenceConstants";

/**
 * Writes telemetry events for Wiki.
 */
export class TelemetryWriter {
    private _wikiType: WikiTypeCI | undefined = undefined;
    constructor(private publishEventFunction: (eventData: TelemetryEventData, immediate?: boolean) => void = publishEvent) { }

    public publish(feature: string, extraProperties: IDictionaryStringTo<any> = {}): void {
        this.publishEventFunction(createWikiEventData(feature, extraProperties, this._wikiType));
    }

    public setWikiType(wikiType: WikiTypeCI): void{
        this._wikiType = wikiType;
    }
}

/**
 * Creates a telemetry event with default data for Wiki.
 */
export function createWikiEventData(
    feature: string,
    extraProperties: IDictionaryStringTo<any> = {},
    wikiType?: WikiTypeCI
): TelemetryEventData {
    const projectId = TfsContext.getDefault().contextData.project.id;
    return new TelemetryEventData(
        Areas.Wiki,
        feature,
        {
            projectId: projectId,
            wikiType,
            ...extraProperties,
        });
}
